import { Injectable } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class PaymentsStoreService {

  private paymentsState = new Subject<any>();
  public paymentsState$ = this.paymentsState.asObservable();

  private selectChartState = new BehaviorSubject<string>('onlinePayments');
  public selectChartState$ = this.selectChartState.asObservable();

  private amountChartState = new Subject<object>();
  public amountChartState$ = this.amountChartState.asObservable();

  private countChartState = new Subject<object>();
  public countChartState$ = this.countChartState.asObservable();


  constructor() { }

  setSelectState(selectedOption: string): void {
    this.selectChartState.next(selectedOption);
  }

  setAmountChart(chartLabels: any[], chartData: any[]) {
    const chartOptions = { chartLabels, chartData };
    // console.log('chartOptions -> ', chartOptions);
    this.amountChartState.next(chartOptions);
  }

  setCountChart(chartLabels: any[], chartData: any[]) {
    const chartOptions = { chartLabels, chartData };
    // console.log('chartOptions -> ', chartOptions);
    this.countChartState.next(chartOptions);
  }
}
